export default __webpack_public_path__ + "static/media/triangleDown.07fed0ed.svg";